import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { noop } from 'ui-components/default-props/noop';

const messages = defineMessages({
  title: {
    description: 'Reporting Categories Placeholder Title',
    defaultMessage: 'You have no {statusView} to view',
    id: '5fCOV8',
  },
  description: {
    description: 'Reporting Categories Placeholder Description',
    defaultMessage: 'No Reporting Categories data to view at the moment',
    id: 'D8QK1c',
  },
  boldStatusView: {
    description: 'Reporting Categories Placeholder Bold Status View Name',
    defaultMessage: 'Reporting Categories',
    id: '5ZqtHS',
  },
});

const ReportingCategoriesGridPlaceholder = () => {
  return (
    <ActionablePlaceholder
      action={noop}
      description={<FormattedMessage {...messages.description} />}
      title={
        <FormattedMessage
          {...messages.title}
          values={{
            statusView: (
              <b>
                <FormattedMessage {...messages.boldStatusView} />
              </b>
            ),
          }}
        />
      }
    />
  );
};

export default ReportingCategoriesGridPlaceholder;
